/**
 * Utility function for handling avatar URLs with fallback support
 * @param {object} user - User object containing avatar information
 * @returns {string|null} - Avatar URL or fallback URL
 */
const getAvatarUrl = (user) => {
  if (!user) return null;
  
  // Priority order for avatar URLs:
  // 1. user.profilePictureUrl
  // 2. user.profile_picture_url
  // 3. user.avatarUrl
  // 4. user.avatar_url
  // 5. user.__fallbackAvatar
  // 6. null
  
  return (
    user.profilePictureUrl ||
    user.profile_picture_url ||
    user.avatarUrl ||
    user.avatar_url ||
    user.__fallbackAvatar ||
    null
  );
};

export default getAvatarUrl;